import fetch from '../../../common/services/api/fetch';
import getQueryStringForPageIdentifiers from '../getQueryStringForPageIdentifiers';

export default function deleteSavedFilter(ids, filterId) {
    const queryString = `${getQueryStringForPageIdentifiers(ids)}&filter_id=${encodeURI(filterId)}`;
    return fetch(
        `/ui/users/preferences/saved_filters/delete${queryString}`,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
        },
        true,
    );
}
